// JavaScript Document
jQuery(document).ready(function($) {
	$(window).load(function () {
		if( parseInt( $('.introduction-wrap').height() ) >= parseInt( $('.fog-bar').data('window-height') ) ){
			$('.fog-bar').show();
		}
	});

	$('.fog-bar').on('click', function(){
		$('.introduction-wrap').css('max-height', 'none');
		$('.fog-bar').remove();
	});
})
